import { ReactNode } from "react";
import BorrowerBizProfile from "../../../Screens/BizProfile/BorrowerBizProfile";
import BorrowerRep from "../../../Screens/BorrowerRep/BorrowerRep";
import BorrowerBank from "../../../Screens/BorrowerBank/BorrowerBank";
import BorrowerDocsUpload from "../../../Screens/DocUpload/BorrowerDoc";

export interface TabDefinition {
  index: string;
  route: string;
  label: string;
  errorKey: string;
}

export const TAB_MAPPING: Record<string, TabDefinition> = {
  businessProfile: {
    index: "0",
    route: "business-profile",
    label: "Business Profile",
    errorKey: "businessProfile",
  },
  representative: {
    index: "1",
    route: "representative",
    label: "Representative",
    errorKey: "representative",
  },
  bankDetails: {
    index: "2",
    route: "bank-details",
    label: "Bank Details",
    errorKey: "bankDetails",
  },
  documents: {
    index: "3",
    route: "documents",
    label: "Documents",
    errorKey: "documents",
  },
};

export const TAB_ARRAY = Object.values(TAB_MAPPING);

export interface TabContentProps {
  onDirtyChange: (dirty: boolean) => void;
  onSaveDraft: (callback: () => void) => void;
  onResetForm: (callback: () => void) => void;
  errors: any;
  onClearError?: (section: string, field: string) => void;
  onSubmit?: () => void;
}

/**
 * Tab content configuration
 * Maps tab index to its component
 */
export const getTabContent = (
  tabIndex: number,
  props: TabContentProps
): ReactNode => {
  const {
    onDirtyChange,
    onSaveDraft,
    onResetForm,
    errors,
    onClearError,
    onSubmit,
  } = props;

  switch (tabIndex) {
    case 0:
      return (
        <BorrowerBizProfile
          onDirtyChange={onDirtyChange}
          onSaveDraft={onSaveDraft}
          onResetForm={onResetForm}
          errors={errors.businessProfile || {}}
          onClearError={(field) => onClearError?.("businessProfile", field)}
        />
      );
    case 1:
      return (
        <BorrowerRep
          onDirtyChange={onDirtyChange}
          onSaveDraft={onSaveDraft}
          onResetForm={onResetForm}
          errors={errors.representative || {}}
          onClearError={(field) => onClearError?.("representative", field)}
        />
      );
    case 2:
      return (
        <BorrowerBank
          onDirtyChange={onDirtyChange}
          onSaveDraft={onSaveDraft}
          onResetForm={onResetForm}
          errors={errors.bankDetails || {}}
          onClearError={(field) => onClearError?.("bankDetails", field)}
        />
      );
    case 3:
      return (
        <BorrowerDocsUpload
          onDirtyChange={onDirtyChange}
          onSaveDraft={onSaveDraft}
          onResetForm={onResetForm}
          onClearError={(field) => onClearError?.("documents", field)}
          onSubmit={onSubmit}
          errors={errors.documents || {}}
        />
      );
    default:
      return null;
  }
};
